var moduleMap = {
	"./Context": () => {
		return Promise.all([__webpack_require__.e(487), __webpack_require__.e(223), __webpack_require__.e(648), __webpack_require__.e(416), __webpack_require__.e(216), __webpack_require__.e(353), __webpack_require__.e(481), __webpack_require__.e(939), __webpack_require__.e(762)]).then(() => (() => ((__webpack_require__(5762)))));
	},
	"./Page": () => {
		return Promise.all([__webpack_require__.e(487), __webpack_require__.e(827), __webpack_require__.e(223), __webpack_require__.e(416), __webpack_require__.e(216), __webpack_require__.e(353), __webpack_require__.e(51), __webpack_require__.e(481), __webpack_require__.e(643), __webpack_require__.e(466)]).then(() => (() => ((__webpack_require__(5466)))));
	},
	"./Theme": () => {
		return Promise.all([__webpack_require__.e(487), __webpack_require__.e(613)]).then(() => (() => ((__webpack_require__(1613)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});